export default "__VITE_ASSET__CQQHy2kY__"